import { render, staticRenderFns } from "./numbsCell.vue?vue&type=template&id=5287c514"
import script from "./numbsCell.vue?vue&type=script&lang=js"
export * from "./numbsCell.vue?vue&type=script&lang=js"
import style0 from "./numbsCell.vue?vue&type=style&index=0&id=5287c514&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports